import { useState } from 'react';
import { createPortal } from 'react-dom';
import {
  ReleaseNotesModal,
  UpdateAvailableModal,
  type UpdateOffer,
} from '@integrations/watchpod/react';
import { api } from '../lib/api';
import { updateActions, updatesUi } from '../lib/integrations';

// Dal tag della versione accanto al logo, come nelle altre app di casa (SurgeAI): le note di
// rilascio del pacchetto condiviso, con «Controlla aggiornamenti» che chiede a WatchPOD; una
// release più nuova apre la sua installazione.
export function VersionModal({ onClose }: { onClose: () => void }) {
  const [offer, setOffer] = useState<UpdateOffer | null>(null);
  const [installing, setInstalling] = useState(false);
  return createPortal(
    installing && offer ? (
      <UpdateAvailableModal
        ui={updatesUi}
        offer={offer}
        actions={updateActions}
        onClose={() => setInstalling(false)}
        onHandled={onClose}
        warning="Si riavvia solo PopTown, per circa un minuto: i lavori in corso riprendono da soli."
      />
    ) : (
      <ReleaseNotesModal
        ui={updatesUi}
        changelog={__APP_CHANGELOG__}
        appVersion={__APP_VERSION__}
        eyebrow="Novità della versione"
        onClose={onClose}
        check={() => api.updates()}
        onUpdateFound={setOffer}
        onInstall={() => setInstalling(true)}
      />
    ),
    document.body,
  );
}
